const cadastro_material_escolar = [
  {
    path: "/cadastro-material-escolar",
    redirect: "/cadastro_material_escolar",
    meta: {
      breadCrumb: "Gestão - Material Escolar",
    },
    children: [
      {
        path: "/cadastro-material-escolar",
        name: "cadastro_material_escolar",
        component: () =>
          import(
            "@/views/CadastroMaterialEscolar/CadastroMaterialEscolarHome.vue"
          ),
      },
      {
        path: "/cadastro-material-escolar/novo",
        name: "cadastro_material_escolar_novo",
        component: () =>
          import(
            "@/views/CadastroMaterialEscolar/CadastroMaterialEscolarCadastro.vue"
          ),
      },
      {
        path: "/cadastro-material-escolar/:id/editar",
        name: "cadastro_material_escolar_editar",
        component: () =>
          import(
            "@/views/CadastroMaterialEscolar/CadastroMaterialEscolarEditar.vue"
          ),
      },
    ],
  },
];

export { cadastro_material_escolar };
